import { Card } from 'baseui/card';
import { HeadingLarge, Paragraph2 } from 'baseui/typography';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setAnswer, setFlowStatus } from '../../actions/userData';
import { scrollTop } from '../../animation/scrollTo';
import ArrowButton from '../../onboard/ArrowButton';
import { CASHFLOW_LINK, SOCIAL_BENEFITS_LINK } from '../flows/linkConstants';
import BreakevenTable from '../social/BreakevenTable';
import CumulativeTableGroup from '../social/CumulativeTableGroup';

//DON"T DELETE MAY NEED
// let takeDate = new Date(ss.dob);
// takeDate.setFullYear(takeDate.getFullYear() + year);
// takeDate = String(takeDate.getMonth() + 1).padStart(2, '0') + '/' + String(takeDate.getDate()).padStart(2, '0') + '/' + String(takeDate.getFullYear())

const SocialSecurityChoiceFlow = ({ mainChoice, spouseChoice, setAnswer, setFlowStatus, mainUserName, spouseUserName }) => {
    const history = useHistory();
    const [jackAmount, setJackAmount] = React.useState(0);
    const [jillAmount, setJillAmount] = React.useState(0);

    React.useEffect(() => {
        if (mainChoice) {
            setJackAmount(mainChoice.takeAmountAnnual)
        }
        if (spouseChoice) {
            setJillAmount(spouseChoice.takeAmountAnnual)
        }
    }, [mainChoice, spouseChoice]);

    function chooseFirst(amount, takeDate) {
        setJackAmount(amount);
        setAnswer('mainSocialSecurity', {
            takeDate: 'takeDate',
            takeAmountAnnual: amount,
        });
    }

    function chooseSecond(amount, takeDate) {
        setJillAmount(amount);
        setAnswer('spouseSocialSecurity', {
            takeDate: 'takeDate',
            takeAmountAnnual: amount,
        });
    }

    return <div>
        <div style={{ justifyContent: "center", textAlign: 'center', width: '100%' }}>
            <HeadingLarge>Social Security: Age Based Benefit Selection</HeadingLarge>
            <Paragraph2>
                The figures below represent the monthly Age Based Benefit you will receive if you file for benefits that year. The spouse with the highest Age Based Benefit at FRA is Jack.
            </Paragraph2>
            <Paragraph2>
                {mainUserName}: Click on the Benefit Value under the age you expect to file for benefits to see your projected figures based on filing that year.
            </Paragraph2>
            <Paragraph2>
                {spouseUserName}:   Click on the highest Benefit Value under the age you expect to file for benefits.
            </Paragraph2>
            <Paragraph2>Spousal benefits are based on a % of the Age Based Benefit of the other spouse. {mainUserName} must file for an Age Based Benefit for {spouseUserName} to have a spousal benefit option (and vice-versa).</Paragraph2>
        </div>
        <div style={{ margin: '0px 25px ', display: 'flex' }}>
            <Card>
                <div style={{}}>
                    <BreakevenTable setJackAmount={chooseFirst} setJillAmount={chooseSecond} />
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 35 }}>
                        <CumulativeTableGroup jackAmount={jackAmount} jillAmount={jillAmount} />
                    </div>
                </div>
            </Card>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'right', margin: '15px 0px' }}>
            <ArrowButton
                action={() => {
                    scrollTop();
                    history.push(SOCIAL_BENEFITS_LINK);
                }}
                disabled={false}
                type='left'
            />
            <ArrowButton
                action={() => {
                    scrollTop();
                    history.push(CASHFLOW_LINK)
                    setFlowStatus({ name: 'choice', status: 'finished' })
                    setFlowStatus({ name: 'cashflow', status: 'finished' })
                }}
                message={'Next'}
                disabled={false}
                type='right'
            />
        </div>
    </div>
}

export default connect(state => {
    return {
        answers: state.userData.answers,
        mainUserName: state.userData.answers.mainUserName,
        spouseUserName: state.userData.answers.spouseUserName,
        mainChoice: state.userData.answers.mainSocialSecurity,
        spouseChoice: state.userData.answers.spouseSocialSecurity,
    }
}, {
    setFlowStatus,
    setAnswer
})(SocialSecurityChoiceFlow);
